import { toast } from 'react-toastify';

const INITIAL_STATE = {
  todas: [],
  carregando: false,
  erro: null,
  especifica: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'REQUISITAR_PUBLICACAO':
      return { ...state, carregando: true };
    case 'ERRO_PUBLICACAO':
      if (action.erro.code === 'ER_ROW_IS_REFERENCED_2') {
        toast.error(
          'Não é possivel deletar está publicação, ela já possui comentarios da comissão.',
          5000
        );
      } else {
        toast.error(action.erro.message, 5000);
      }
      return { ...state, carregando: false, erro: action.erro };
    case 'OBTER_PUBLICACAO':
      return { ...state, carregando: false, especifica: action.publicacao };
    case 'OBTER_PUBLICACOES':
      return { ...state, carregando: false, todas: action.publicacoes };
    case 'REMOVER_PUBLICACAO':
      toast.success('Publicação removida');
      return {
        ...state,
        carregando: false,
        todas: state.publicacoes
          ? state.publicacoes.filter((p) => p.id !== action.publicacao)
          : [],
      };
    case 'EDITAR_PUBLICACAO':
      return {
        ...state,
        carregando: false,
        todas: state.publicacoes
          ? state.publicacoes
              .filter((publicacao) => publicacao.id !== action.publicacao.id)
              .concat(action.publicacao)
              .sort(
                (a, b) =>
                  new Date(a.dataPublicacao) + new Date(b.dataPublicacao)
              )
          : [],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/PublicacaoReducer.js